import { developmentDiagnosticsEnabled } from './diagnostics';
const allowedAnchorProtocols = new Set([
    'http:',
    'https:',
    'mailto:',
    'tel:'
]);
function rejectedHref(href, reason) {
    if (developmentDiagnosticsEnabled) {
        console.warn(`safeAnchorHref rejected ${JSON.stringify(href)} (${reason}).`);
    }
    return undefined;
}
/** Returns a fallback-anchor href only when its scheme is safe to navigate. */ export function safeAnchorHref(href) {
    // URL parsing removes ASCII tab/newline characters and leading C0 controls
    // before it recognizes a scheme. Normalize the same way so an obfuscated
    // executable scheme cannot bypass the allowlist.
    let normalized = href.replace(/[\t\n\r\0]/g, '');
    while(normalized && normalized.charCodeAt(0) <= 0x20)normalized = normalized.slice(1);
    normalized = normalized.trim();
    if (!normalized) return undefined;
    if (/^[\\/]{2}/.test(normalized)) return rejectedHref(href, 'protocol-relative URL');
    const scheme = /^[a-z][a-z\d+.-]*:/i.exec(normalized)?.[0].toLowerCase();
    return !scheme || allowedAnchorProtocols.has(scheme) ? normalized : rejectedHref(href, `disallowed scheme ${scheme}`);
}
